import React from "react"

export function Lock({
  fill = "#302B85",
  h = 28,
  w = 23,
  className,
}: {
  fill?: string
  h?: number
  w?: number
  className: string
}) {
  return (
    <svg width={w} height={h} viewBox="0 0 23 28" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3H11C8.23858 3 6 5.23858 6 8V10H17V8C17 5.23858 14.7614 3 12 3ZM3 8V10C1.34315 10 0 11.3431 0 13V25C0 26.6569 1.34315 28 3 28H20C21.6569 28 23 26.6569 23 25V13C23 11.3431 21.6569 10 20 10V8C20 3.58172 16.4183 0 12 0H11C6.58172 0 3 3.58172 3 8ZM12.1582 13L16.3164 17.1582L13.9863 19.4883V24H9.98633V19.1445L8 17.1582L12.1582 13Z"
        fill={fill}
      />
    </svg>
  )
}
